// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';



$w.onReady(function () {
	$w("#source").value = decodeURI(wixLocation.query.utm_source);
	//	wixLocation.query
});
